import { render, staticRenderFns } from "./mainObjCell.vue?vue&type=template&id=e253a556&scoped=true&"
import script from "./mainObjCell.vue?vue&type=script&lang=js&"
export * from "./mainObjCell.vue?vue&type=script&lang=js&"
import style0 from "./mainObjCell.vue?vue&type=style&index=0&id=e253a556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e253a556",
  null
  
)

export default component.exports